import Cookies from 'js-cookie'

const COOKIE_NAME = 'si_2_settings'
const DAYS_EXPIRE = 60
//
// private functions to manage encoding
// and decoding values in main cookie
//

const isJson = () => {
  const currentJson = Cookies.get(COOKIE_NAME)
  try {
    JSON.parse(currentJson)
    return true
  } catch (e) {
    return false
  }
}
const getExisting = () => {
  if (isJson()) {
    const currentJson = Cookies.get(COOKIE_NAME)
    const json = JSON.parse(currentJson)
    if (typeof json !== 'object' || json === null) {
      return {}
    }
    return json
  }
  return { }
}
const encodeValue = (name, value) => {
  const object = getExisting()
  object[name] = value
  Cookies.set(COOKIE_NAME, JSON.stringify(object), { expires: DAYS_EXPIRE })
}

const decodeName = (name) => {
  if (!isJson()) {
    return null
  }
  const cookie = Cookies.get(COOKIE_NAME)
  const decode = JSON.parse(cookie)
  if (!(name in decode)) {
    return null
  }
  return decode[name]
}

//
// Public Functions (exported)
//
const updateValue = (name, value) => {
  encodeValue(name, value)
}

const deleteValue = (name) => {
  const object = getExisting()
  if (name in object) {
    delete object[name]
  }
  Cookies.set(COOKIE_NAME, JSON.stringify(object), { expires: DAYS_EXPIRE })
}

const fetchValue = (name) =>
  decodeName(name)

export {
  updateValue,
  deleteValue,
  fetchValue,
}
